import { NgClass, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IImage } from '@ncg/data';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { UtilsModule } from '../../utils/utils.module';

@Component({
    selector: 'ncg-model-viewer-lead',
    template: `
        <div class="columns is-centered is-variable is-2 is-multiline is-mobile">
            <div class="column is-relative is-narrow pt-0 pb-2" *ngFor="let item of arr; let index = index">
                <div
                    class="is-flex model-lead-image pb-0 mb-1 is-clickable"
                    [ngClass]="{ 'is-active': index === selectedIndex }"
                    (click)="onClick(index)">
                    <img width="48" height="48" [src]="item?.url + '?width=96&height=96'" alt="" ncgImageLoad />
                    <div class="model-lead-marker" [ngClass]="{ 'is-active': index === selectedIndex }">
                        <svg-icon-sprite
                            src="checkmark"
                            [viewBox]="'0 0 30 30'"
                            [width]="'17px'"
                            [height]="'17px'"
                            aria-hidden="true"
                            class="model-lead-icon icon is-flex"></svg-icon-sprite>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns" *ngIf="title">
            <div class="column">
                <h3 class="model-lead__title has-text-centered">{{ title }}</h3>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, IconSpriteModule, UtilsModule, NgForOf, NgIf],
})
export class ModelViewerLeadComponent {
    public selectedIndex = 0;

    @Output()
    public leadClick: EventEmitter<number> = new EventEmitter();

    @Input()
    public arr: IImage[];

    @Input()
    public title?: string;

    public onClick(index: number) {
        this.selectedIndex = index;
        this.leadClick.emit(index);
    }
}
